import RenewalStatementsDialog from './renewal.statements.dialog.component';
export default angular.module('', []).component('renewalStatementsDialog', RenewalStatementsDialog).name;